//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HelloWorld from "./components/HelloWorld.vue";

export default {
  name: "LayoutDefault",

  components: {
    HelloWorld
  },

  data() {
    return {
      leftDrawerOpen: false,
      window: {
        width: 0,
        height: 0
      }
    };
  },

  methods: {
    cekToken(){
      fetch(this.$store.state.url.URL_APP + "checkAuth", {
          method: "GET",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          }
      })
          .then(res => res.json())
          .then(res_data => {
              if (res_data.message == 'Tidak ter-Authorisasi') {
                localStorage.removeItem("token");
                localStorage.removeItem("profile");
                this.$store.state.CHECK_AUTH = false
              } else{
                var profile1 = localStorage.profile;
                var profile2 = JSON.parse(profile1);
                var profile3 = profile2.profile

                this.$store.state.userx.nama = profile3.nama;
                this.$store.state.userx.email = profile3.email;
                this.$store.state.userx.hp = profile3.hp


                console.log(profile3.nama)
                return false
              }
      });
    },
  },

  mounted () {
    this.cekToken();
  },

 
};
